<!-- The modal also uses classes from the dialog component and should be kept in sync -->
<div class="se-dialog__overlay"></div>
<div class="se-dialog__container">
  <div class="se-dialog__content">
    <ng-content></ng-content>
  </div>
  <se-dialog-footer
    [se-data-buttons]="buttons"
    (se-data-action)="awaitAction($event)">
  </se-dialog-footer>
</div>
